import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PoliticaEntregaExcelImportResponseDto, RegionPoliticaDto } from '../models/politica-entrega.dto';
import { PoliticaEntregaSaveCommand } from '../models/politica-entrega.model';
import { PoliticaEntregaMapper } from '../pages/politicas-entrega/mappers/politica-entrega.mapper';
import { PoliticaEntregaRowVm } from '../models/politica-entrega.vm';

@Injectable()
export class PoliticaEntregaApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}cemento/politica/`;

  getRegiones(): Observable<RegionPoliticaDto[]> {
    return this.http.get<RegionPoliticaDto[]>(`${this.baseUrl}regiones/`);
  }

  getPoliticas(regionCodigo: number, incoterms: string): Observable<PoliticaEntregaRowVm[]> {
    const incotermsEncoded = encodeURIComponent(incoterms);
    return this.http
      .get<unknown>(`${this.baseUrl}dt/${regionCodigo}/${incotermsEncoded}/`)
      .pipe(
        map((raw) => {
          const rows = PoliticaEntregaMapper.toRowsVm(raw);
          return rows;
        }),
      );
  }

  createUpdatePolitica(command: PoliticaEntregaSaveCommand): Observable<void> {
    return this.http
      .post<unknown>(`${this.baseUrl}update_crear/`, {
        region: command.regionCodigo,
        comuna: command.comuna,
        incoterms: command.incoterms,
        centro: command.centro,
        pallet: command.pallet,
        horas: command.horas,
      })
      .pipe(map(() => undefined));
  }

  deletePoliticaById(id: number): Observable<void> {
    return this.http.delete<unknown>(`${this.baseUrl}${id}/`).pipe(map(() => undefined));
  }

  postExcelPolitica(file: File): Observable<PoliticaEntregaExcelImportResponseDto> {
    const formData = new FormData();
    formData.append('excel', file);
    return this.http.post<PoliticaEntregaExcelImportResponseDto>(`${this.baseUrl}cargar_excel/`, formData);
  }
}
